import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant23() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title: 'Сайт под ключ без стартовых вложений.',
      step1: 'Дизайн и разработка',
      step2: 'Безлимитные правки',
      step3: 'Хостинг и поддержка',
      cta: 'Обсудить проект'
    },
    ua: {
      title: 'Сайт під ключ без стартових вкладень.',
      step1: 'Дизайн та розробка',
      step2: 'Безлімітні правки',
      step3: 'Хостинг та підтримка',
      cta: 'Обговорити проєкт'
    },
    en: {
      title: 'Turnkey website with no upfront costs.',
      step1: 'Design & Development',
      step2: 'Unlimited edits',
      step3: 'Hosting & Support',
      cta: 'Discuss project'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-502">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-503">
          {/* Left Column - Visual Math */}
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-504">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="mb-8 text-4xl md:text-5xl lg:text-6xl font-black leading-[1.1] tracking-tight text-gray-900" data-id="element-505">
              {content.title}
            </motion.h1>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2
          }} className="w-full max-w-md space-y-3 mb-10" data-id="element-506">
              <div className="flex items-center justify-between p-4 rounded-2xl bg-white border border-gray-100 shadow-sm" data-id="element-507">
                <div className="flex items-center gap-3" data-id="element-508">
                  <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-509" />
                  <span className="font-semibold text-gray-800" data-id="element-510">
                    {content.step1}
                  </span>
                </div>
                <span className="font-black text-xl text-green-500" data-id="element-511">0$</span>
              </div>
              <div className="flex items-center justify-between p-4 rounded-2xl bg-white border border-gray-100 shadow-sm" data-id="element-512">
                <div className="flex items-center gap-3" data-id="element-513">
                  <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-514" />
                  <span className="font-semibold text-gray-800" data-id="element-515">
                    {content.step2}
                  </span>
                </div>
                <span className="font-black text-xl text-green-500" data-id="element-516">0$</span>
              </div>
              <div className="flex items-center justify-between p-4 rounded-2xl bg-blue-50 border border-blue-100 shadow-sm" data-id="element-517">
                <div className="flex items-center gap-3" data-id="element-518">
                  <CheckCircle2 className="w-6 h-6 text-blue-500" data-id="element-519" />
                  <span className="font-semibold text-blue-900" data-id="element-520">
                    {content.step3}
                  </span>
                </div>
                <span className="font-black text-xl text-blue-600" data-id="element-521">
                  {price}/мес
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} data-id="element-522">
              <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-2xl px-10 py-4 font-bold text-lg transition-all hover:scale-105 w-full sm:w-auto" style={{
              backgroundColor: 'var(--accent)',
              color: '#FFFFFF'
            }} data-id="element-523">
                {content.cta}
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-524" />
              </button>
            </motion.div>
          </div>

          {/* Right Column - Clean Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative mt-12 lg:mt-0" data-id="element-525">
            <div className="relative w-full max-w-2xl mx-auto rounded-[2rem] overflow-hidden shadow-2xl border-4 border-white" data-id="element-526">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-527" />
            </div>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-528" />
    </>;
}